import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const AiAgentsIndex = () => import('./Index.vue');
const AiAgentsEdit = () => import('./Edit.vue');
const AiAgentsProvider = () => import('./Provider.vue');

// SiteUp (unificação Captain×AiAgents): o Captain é a entrada PRINCIPAL de
// agente (sidebar "Captain" + "Motor de IA" movido pra lá). O construtor nativo/
// n8n (lista + builder) NÃO está no sidebar — continua acessível só por URL.
//
// IMPORTANTE (decisão do Lucas): NÃO gatear o builder. Em produção há contas
// com agentes n8n ATIVOS (AgentBotInbox) que precisam ser migrados pro Captain
// INDIVIDUALMENTE (trabalho por conta). Gatear tiraria o acesso de edição deles.
// O banner em Edit.vue já aponta pro Captain. O gateamento total fica pra depois
// do cutover por conta.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-agents'),
      meta: {
        permissions: ['administrator', 'ai_agents_view'],
        featureFlag: 'ai_agent',
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ai_agents',
          component: AiAgentsIndex,
          meta: {
            permissions: ['administrator', 'ai_agents_view'],
          },
        },
        {
          path: 'new',
          name: 'ai_agents_new',
          component: AiAgentsEdit,
          meta: {
            permissions: ['administrator', 'ai_agents_view'],
          },
        },
        {
          path: 'provider',
          name: 'ai_agents_provider',
          component: AiAgentsProvider,
          meta: {
            permissions: ['administrator', 'ai_agents_view'],
          },
        },
        {
          path: ':agentId',
          name: 'ai_agents_edit',
          component: AiAgentsEdit,
          meta: {
            permissions: ['administrator', 'ai_agents_view'],
          },
        },
      ],
    },
  ],
};
